"use client";
import { LandingBlogGetSidebarDataOutputApiModel } from "@/Apis/ClinicApi";
import { If, SmartImage, SmartLink } from "@/Components";
import sp from "@/Helpers/searchParam";
import { useSearchHref, useT } from "@/Hooks";
import _ from "lodash";
import moment from "moment-jalaali";
import { useSearchParams } from "next/navigation";
import { FC } from "react";
import StickyBox from "react-sticky-box";
import "./StickySidebarClient.css";
import StickySidebarSearch from "./StickySidebarSearch";

interface StickySidebarClientProps {
  result: LandingBlogGetSidebarDataOutputApiModel;
}

const StickySidebarClient: FC<StickySidebarClientProps> = ({ result }) => {
  const buildHref = useSearchHref();
  const searchParams = useSearchParams();
  const t = useT();

  const activeCategoryId = sp.int(searchParams?.get("categoryId"));
  const activeTagId = sp.int(searchParams?.get("tagId"));

  const categories = result.Categories.filter(
    (category) => category.BlogsCount,
  );
  return (
    <>
      <StickyBox>
        {/* Search */}
        <StickySidebarSearch />
        {/* /Search */}
        <If condition={!_.isEmpty(result.Blogs)}>
          {/* Latest Posts */}
          <div className="card post-widget">
            <div className="card-body">
              <h5 className="mb-3">
                {t(
                  "landing.blog.sidebar.popularPosts",
                  undefined,
                  "Popular posts",
                )}
              </h5>
              <ul className="latest-posts">
                {result.Blogs.map((blog) => (
                  <li key={blog.Id}>
                    <div className="post-thumb">
                      <SmartLink href={blog.Link}>
                        <SmartImage
                          cover
                          className="img-fluid"
                          src={blog.ImageUrl}
                          alt={blog.Title}
                          width={75}
                          height={75}
                        />
                      </SmartLink>
                    </div>
                    <div className="post-info">
                      <p>
                        {moment(blog.DateRegister).format("jDD jMMMM jYYYY")}
                      </p>
                      <h4>
                        <SmartLink href={blog.Link}>{blog.Title}</SmartLink>
                      </h4>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* /Latest Posts */}
        </If>
        <If condition={!_.isEmpty(categories)}>
          {/* Categories */}
          <div className="card category-widget">
            <div className="card-body">
              <h5 className="mb-3">
                {t("landing.blog.sidebar.categories", undefined, "Categories")}
              </h5>
              <ul className="categories">
                {categories?.map((category) => (
                  <li key={category.Id}>
                    <SmartLink href={category.Link}>
                      {category.Name} <span>({category.BlogsCount})</span>
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* /Categories */}
        </If>
        <If condition={!_.isEmpty(result.Tags)}>
          {/* Tags */}
          <div className="card tags-widget">
            <div className="card-body">
              <h5 className="mb-3">
                {t("landing.blog.sidebar.tags", undefined, "Tags")}
              </h5>
              <ul className="tags">
                {result.Tags.map((tag) => (
                  <li key={tag.Id}>
                    {/* buildHref({ categoryId: null, tagId: tag.Id, }) */}
                    <SmartLink href={tag.Link} className="tag">
                      {tag.Name}
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* /Tags */}
        </If>
      </StickyBox>
    </>
  );
};

export default StickySidebarClient;
